export default [
    {
        path: '/auth/result',
        name: 'authresult',
        component: () => import(/* webpackChunkName: "auth" */'@/views/auth/AuthResult.vue'),
        meta: {
            title: 'AuthResult',
            hideInMenu: true,
        },
    },
    {
        path: '/auth/shop',
        name: 'authShop',
        meta: {
            title: 'AuthShop',
            hideInMenu: true,
        },
        component: () => import(/* webpackChunkName: "auth" */'@/views/auth/AuthorizedShop.vue'),
    },
    {
        path: '/auth/third',
        name: 'authThird',
        meta: {
            title: 'authThird',
            hideInMenu: true,
        },
        component: () => import(/* webpackChunkName: "auth" */'@/views/auth/UnauthorizedShop.vue'),
    },
    {
        path: '/auth/workweixin',
        name: 'authWorkWeixin',
        meta: {
            title: 'authWorkWeixin',
            hideInMenu: true,
        },
        component: () => import(/* webpackChunkName: "auth" */'@/views/auth/WorkWeixin.vue'),
    },
    {
        path: '/auth/sso',
        name: 'authSSO',
        meta: {
            hideInMenu: true,
        },
        component: () => import(/* webpackChunkName: "auth" */'@/views/auth/SSO.vue'),
    },
    {
        path: '/auth/sso_failed',
        name: 'authSSOFailed',
        meta: {
            hideInMenu: true,
        },
        component: () => import(/* webpackChunkName: "auth" */'@/views/auth/SSOFailed.vue'),
    },
];
